import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  Row, Col, Nav, Tab,
} from 'react-bootstrap5';

import routes from 'app/routes';
import Alert from 'components/new_ui/Alerts/alert';
import { useContext as useUsersContext } from 'components/Users/Context';
import LearningStyleForm from 'components/Members/LearningStyle/Widgets/LearningStyleForm/Index';
import MyPreferencesForm from 'components/Members/LearningStyle/Widgets/MyPreferencesForm/Index';

export default function Index() {
  const { dispatch: dispatchUsers, actions: actionsUsers } = useUsersContext();

  const navigate = useNavigate();

  return (
    <div className="content">
      <section>
        <Row className="align-items-center">
          <Col>
            <h1>Learning Style</h1>
          </Col>

          <Col xs="auto">
            <Link
              to={routes.members.learningStyle.show}
              className="btn btn-primary"
            >
              View
            </Link>
          </Col>
        </Row>
      </section>

      <Tab.Container
        id="learning-style"
        defaultActiveKey="my-style"
      >
        <Nav fill justify variant="tabs">
          <Nav.Item>
            <Nav.Link eventKey="my-style">
              My Style
            </Nav.Link>
          </Nav.Item>

          <Nav.Item>
            <Nav.Link eventKey="my-preferences">
              My Preferences
            </Nav.Link>
          </Nav.Item>
        </Nav>

        <Tab.Content>
          <Tab.Pane eventKey="my-style" className="px-sm-4 px-xxl-5">
            <LearningStyleForm
              afterSubmit={() => {
                navigate(routes.members.learningStyle.show);
                actionsUsers.load(
                  dispatchUsers,
                  () => {
                    Alert({
                      text: 'My Style updated successfully.',
                    });
                  },
                );
              }}
            />
          </Tab.Pane>

          <Tab.Pane eventKey="my-preferences" className="px-sm-4 px-xxl-5">
            <MyPreferencesForm
              afterSubmit={() => {
                navigate(routes.members.learningStyle.show);
                actionsUsers.load(
                  dispatchUsers,
                  () => {
                    Alert({
                      text: 'My Preferences updated successfully.',
                    });
                  },
                );
              }}
            />
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container>
    </div>
  );
}
